import { Controller } from "@hotwired/stimulus"

// QAN-480: Hot Bank Reverse Lookup results table. Drives the "select all"
// checkbox, keeps it in sync with the row checkboxes, and enables the bulk-add
// submit button only when at least one client is selected.
export default class extends Controller {
  static targets = ["selectAll", "row", "submit"]

  connect() {
    this.refresh()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.rowTargets.forEach((row) => { row.checked = checked })
    this.refresh()
  }

  refresh() {
    const selected = this.rowTargets.filter((row) => row.checked).length

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = selected > 0 && selected === this.rowTargets.length
      this.selectAllTarget.indeterminate = selected > 0 && selected < this.rowTargets.length
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = selected === 0
      this.submitTarget.value = selected > 0
        ? `Add to ${selected} selected ${selected === 1 ? "plan" : "plans"}`
        : "Add to selected plans"
    }
  }
}
